import { render, staticRenderFns } from "./VlIndexLabels.vue?vue&type=template&id=021e2db2&scoped=true&"
import script from "./VlIndexLabels.vue?vue&type=script&lang=js&"
export * from "./VlIndexLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021e2db2",
  null
  
)

export default component.exports